import {Drawer, Stack, TextField} from "@mui/material";
import {useState} from "react";
import {addPayer, generatePayerKeyFromPayerName, PayerModel, TripModel} from "../../firebase/index.js";
import {useInMemoryTrip} from "../../redux/InMemoryTripReducer.js";
import APXActionButtons from "../../reusables/APXActionButtons.jsx";
import APXNumberSelector from "../../reusables/APXNumberSelector.jsx";
import type {BSLProps} from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../reusables/js/APXBottomSheetLayoutUtils.js";


export default function AddNewPayerBSL({uid, onClose}: BSLProps) {
	  const [name, setName] = useState("");
	  const [payingFor, setPayingFor] = useState(1);
	  
	  const inMemoryTrip: TripModel = useInMemoryTrip();
	  
	  const {isOpen, handleOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  const handleCancel = () => {
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 if (/*FALSY->*/ !!!uid) {
					alert("Please login to add a new reimbursement");
					return;
			 }
			 if (/*FALSY->*/ !!!name) {
					alert("Please enter a name");
					return;
			 }
			 
			 const payerKey = generatePayerKeyFromPayerName(name);
			 const payer = new PayerModel(payerKey, name.trim(), payingFor);
			 
			 addPayer(uid, inMemoryTrip.expenditureKey, payerKey, payer);
			 
			 handleCancel();
	  };
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  <Stack direction="row" spacing={2}>
									 <TextField required sx={{width: "200%", mr: 2}} variant="outlined" label="Name"
													value={name} onChange={(event) => setName(event.target.value)}
									 />
									 <APXNumberSelector required title="Paying for" value={payingFor} max={10} onChange={(event) => setPayingFor(event.target.value)}/>
							  </Stack>
							  <APXActionButtons onAdd={handleAdd} onCancel={handleCancel}/>
						</Stack>
				 </Drawer>
	  );
}